import React from 'react'
import BSModal from 'react-bootstrap/Modal'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { closeModal as closeModalAction } from './modalSlice'
import { Modal as ModalType } from './types'
import { RootState } from '../../store'

interface ModalProps extends ModalType {
    closeModal: (id: number) => void;
}

const S = {
    Header: styled(BSModal.Header)`
        padding: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        margin-bottom: -8px;
        font-weight: 500;
        font-size: 30px;
        line-height: 35px;
        color: #2D3035;
        border: none;
        & > button {
            font-size: 32px;
            font-weight: 400;
            color: #78909C;
            opacity: 1;
        }
    `,
    HeaderInner: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    `,
}

const renderHeaderComponent = (Component) => <Component />

const Modal = ({
    id,
    header,
    closeModal,
    Component,
    size = 'lg',
    callback = () => undefined,
    padding = 20,
    backdrop = true,
    scrollable,
}: ModalProps) => {
    const [show, setShow] = React.useState(true)
    const close = (withAnimation = true) => {
        setShow(false)
        setTimeout(() => {
            closeModal(id)
            callback()
        }, withAnimation ? 250 : 0)
    }

    return !Component ? null : (
        <BSModal
            show={show}
            onHide={close}
            centered
            backdrop={backdrop}
            size={size}
            scrollable={scrollable}
        >
            {
                header
                && (
                    <S.Header closeButton>
                        <S.HeaderInner>
                            {
                                typeof header === 'string'
                                    ? <span>{header}</span>
                                    : renderHeaderComponent(header)
                            }
                        </S.HeaderInner>
                    </S.Header>
                )
            }

            <BSModal.Body style={{ padding }}>
                <Component close={close} />
            </BSModal.Body>
        </BSModal>
    )
}

const ModalContainer = () => {
    const modals = useSelector((state: RootState) => state.modals)
    const dispatch = useDispatch()
    const values = Object.values(modals)
    return values.length === 0 ? null : (
        <div>
            { values.map((modal) => (modal.shouldNotWrap ? (
                <modal.Component close={() => dispatch(closeModalAction(modal.id))} key={modal.id} />
            ) : (
                <Modal
                    {...modals[modal.id]}
                    closeModal={(id: number) => dispatch(closeModalAction(id))}
                    key={modal.id}
                />
            )))}
        </div>
    )
}

export default ModalContainer
